import React, {createContext, useContext, useReducer} from "react";
import {removeSessionCookie, setSessionCookie} from "../utils/auth";


function reducer(state, action) {
    switch (action.type) {
        case "SET_USER":
            setSessionCookie(action.user.sessionId);
            localStorage.setItem("user", JSON.stringify(action.user));
            localStorage.setItem("permissions", JSON.stringify(action.permissions));
            localStorage.setItem("navigation", JSON.stringify(action.navigation));

            return { ...state, info: {...action.user}, permissions: {...action.permissions}, navigation: {...action.navigation}};

        case "CLEAR_USER":
            removeSessionCookie();
            localStorage.removeItem("user");
            localStorage.removeItem("permissions");
            localStorage.removeItem("navigation");
            return  {info: null, permissions: null, navigation: null};

        default:
            return state;
    }
}

const localStorageUser = JSON.parse(localStorage.getItem("user"));
const localStoragePermissions = JSON.parse(localStorage.getItem("permissions"));
const localStorageNavigation = JSON.parse(localStorage.getItem("navigation"));

const UserContext = createContext();

export function useUserContext() {
    const context = useContext(UserContext);
    if (!context) {
        throw new Error('useUserContext must be used within UserProvider!');
    }

    return context;
}

export function UserProvider(props) {
    const [user, dispatch] = useReducer(reducer, {
        info: localStorageUser || null,
        permissions: localStoragePermissions || null,
        navigation: localStorageNavigation || null,
    });
    const value = { user, dispatch };

    return <UserContext.Provider value={value} {...props}/>
}